import { GildButton } from './GildButton.js';

interface ConnectButtonProps {
  label: string;
  busyLabel?: string;
  busy?: boolean;
  disabled?: boolean;
  onClick: () => void;
  className?: string;
}

/**
 * ConnectButton — wallet sign-in, rendered as the shared "Living Border" gold
 * CTA (see GildButton / `.gild-cta`) so it matches every other primary button
 * across the app.
 */
export function ConnectButton({
  label,
  busyLabel = 'Connecting…',
  busy = false,
  disabled = false,
  onClick,
  className,
}: ConnectButtonProps) {
  return (
    <GildButton
      busy={busy}
      busyLabel={busyLabel}
      disabled={disabled}
      onClick={onClick}
      className={className}
    >
      {label}
    </GildButton>
  );
}
